import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchCandidateActiveResumeBuilder, CandidateResumeBuilder } from "./CandidateActiveResumeBuilderAPI"

const initialState = {
    data: null, // store the full API response object
    loading: false,
    error: null,
    createLoading: false,
    createError: null,
    createSuccess: false,
}

export const fetchCandidateActiveResumeBuilderAsync = createAsyncThunk(
    "CandidateActiveResumeBuilder/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchCandidateActiveResumeBuilder()
            const res = data?.response
            return res
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

export const createCandidateResumeBuilderAsync = createAsyncThunk(
    "CandidateActiveResumeBuilder/create",
    async (resumeBuilderUuid, { rejectWithValue }) => {
        try {
            const data = await CandidateResumeBuilder(resumeBuilderUuid)
            return data
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)




const ActiveResumeBuilderSlice = createSlice({
    name: "ActiveResumeBuilder",
    initialState,
    reducers: {
        clearCreateState: (state) => {
            state.createLoading = false
            state.createError = null
            state.createSuccess = false
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch cases
            .addCase(fetchCandidateActiveResumeBuilderAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchCandidateActiveResumeBuilderAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
                state.error = null
            })
            .addCase(fetchCandidateActiveResumeBuilderAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || action.error.message
            })
            // Create cases
            .addCase(createCandidateResumeBuilderAsync.pending, (state) => {
                state.createLoading = true
                state.createError = null
                state.createSuccess = false
            })
            .addCase(createCandidateResumeBuilderAsync.fulfilled, (state, action) => {
                state.createLoading = false
                state.createError = null
                state.createSuccess = true
                // Optionally update the data to reflect the new state
                if (state.data && state.data.data) {
                    const updatedData = state.data.data.map((item) => {
                        if (item.uuid === action.meta.arg) {
                            return { ...item, resume_builder_candidate_count: 1 }
                        }
                        return item
                    })
                    state.data = { ...state.data, data: updatedData }
                }
            })
            .addCase(createCandidateResumeBuilderAsync.rejected, (state, action) => {
                state.createLoading = false
                state.createError = action.payload || action.error.message
                state.createSuccess = false
            })


    },
})

export const { clearCreateState } = ActiveResumeBuilderSlice.actions
export const selectActiveResumebuilder = (state) => state.activeResumeBuilder.data
export const selectCreateResumeBuilderState = (state) => ({
    loading: state.activeResumeBuilder.createLoading,
    error: state.activeResumeBuilder.createError,
    success: state.activeResumeBuilder.createSuccess,
})

export default ActiveResumeBuilderSlice.reducer
